
angular.module('app.controllers.carousel', []).controller('swgCarouselController',
    ['$scope', '$timeout', '$animate', function ($scope, $timeout, $animate) {

  'use strict';
  $scope.loaded = false;
  $scope.slideDelayInterval = 5000;
  $timeout(function() {
    $animate.enabled(true,angular.element(".carousel"));
    $scope.loaded = true;
  });
}]);
